/*
  Cookie banner — Decline opens the preferences panel
  ---------------------------------------------------
  INTERIM, pending a business decision (docs/CONSENT_BANNER_SLIM_RAIL.md).
  Restores the behaviour the theme had from 2025-08-16 (28d3c2e7) until the
  Slim Rail rebuild removed it on 2026-08-19: a click on the banner's Decline
  button records no choice and opens Shopify's preferences panel instead,
  where the shopper can accept, or switch categories off and save.

  HOW   One capture-phase click listener on `window` — the first node on every
        click's path — so it runs before Shopify's own listeners on the button
        and stops the event before they see it. Those listeners are what write
        the decline and report it to Shopify, so neither happens. The rebuild
        replaced a 98-line inline script that found the button by its English
        label and kept a MutationObserver walking every button on the page on
        each DOM change for the whole visit; a delegated listener needs neither,
        and still catches a banner injected after DOMContentLoaded or re-rendered.

  IF THE PANEL BUTTON IS MISSING, Decline is left alone and declines — the old
  script swallowed the click and left the shopper with a dead button.

  Shopify owns the banner's markup, so this is a plain script, not a custom
  element. Both ids come from storefront-banner.js and are the same ones
  assets/component-consent-banner.css styles.
*/
(() => {
  if (window.consentDeclinePreferences) return;
  window.consentDeclinePreferences = true;

  const DECLINE_SELECTOR = '#shopify-pc__banner__btn-decline';
  const PREFERENCES_ID = 'shopify-pc__banner__btn-manage-prefs';

  window.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element) || !event.target.closest(DECLINE_SELECTOR)) return;

      const preferences = document.getElementById(PREFERENCES_ID);
      if (!preferences) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      preferences.click();
    },
    true
  );
})();
